module.exports = __webpack_public_path__ + "img/game-handle.f73a3739.svg";